module.exports = __webpack_public_path__ + "static/img/xszg.3937ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xszg.jpg
// module id = CeCb
// module chunks = 1